import { useIntl } from 'react-intl';
import { useMediaQuery, useTheme } from '@mui/material';

import brandImage from '../../../../assets/images/brand-pages/ao1dmax-mf-30.png';
import brandImageMobile from '../../../../assets/images/brand-pages/ao1dmax-mf-30-mobile.png';
import clarity from '../../../../assets/images/brand-pages/clarity.svg';
import { BrandPage } from './brand-page';

export const BrandPageClarity = (): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const intl = useIntl();

  return (
    <>
      <BrandPage
        title={intl.formatMessage(
          { id: 'brandPages.brand1.title' },
          {
            linebreak: <br />,
            sup: (chunks: React.ReactNode) => <sup>{chunks}</sup>,
          },
        )}
        brandImage={isMobile ? brandImageMobile : brandImage}
        topIcon={clarity}
        description={intl.formatMessage(
          { id: 'brandPages.brand1.details' },
          {
            linebreak: !isMobile && <br />,
            sup: (chunks: React.ReactNode) => <sup>{chunks}</sup>,
          },
        )}
        legal={intl.formatMessage(
          { id: 'brandPages.brand1.description' },
          { sup: (chunks: React.ReactNode) => <sup>{chunks}</sup> },
        )}
      />
    </>
  );
};
